
import { motion } from "framer-motion";
import { GraduationCap } from "lucide-react";

const QuizHeader = () => {
  return (
    <div className="text-center mb-8">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="inline-flex items-center gap-2"
      >
        <GraduationCap className="w-6 h-6 text-corporate-primary-75" />
        <h1 className="text-2xl font-bold text-corporate-primary-100">Crypto Trading Quiz</h1>
      </motion.div>
    </div>
  );
};

export default QuizHeader;
